import axios from "axios";
import getConfig from "next/config";
import * as _ from "lodash";
import has from "lodash/has";
import { get as lodashGet } from "lodash";
import includes from "lodash/includes";
import map from "lodash/map";
import size from "lodash/size";

const envConfig = getConfig();
const axiosInstance = axios.create({});

axiosInstance.interceptors.response.use((response) => {
	let modifiedRes = {
		...response,
		request: {}
	};

	return JSON.parse(JSON.stringify(modifiedRes));
}, (error) => {
	console.log("Interceptors");
	console.log("error", {error});

	return Promise.reject(error);
});

const request = (url: string, options: any) =>
	axiosInstance(url, options)
		.then(handleResponse)
		.catch(handleError);

export const put = (url: string, options: any) =>
	request(`${_.get(envConfig.publicRuntimeConfig, "datalayerurl", "")}${url}`, {
		...options,
		method: "PUT"
	});

export const post = (url: string, options: any) =>
	request(`${_.get(envConfig.publicRuntimeConfig, "datalayerurl", "")}${url}`, {
		...options,
		method: "POST"
	});

export const get = (url: string, options: any) =>
	request(`${_.get(envConfig.publicRuntimeConfig, "datalayerurl", "")}${url}`, {
		...options,
		method: "GET"
	});

export const getBsp = (url: string, options: any) =>
	request(`${_.get(envConfig.publicRuntimeConfig, "bspdatalayerurl", "")}${url}`, {
		...options,
		method: "GET"
	});

export const putBsp = (url: string, options: any) =>
	request(`${_.get(envConfig.publicRuntimeConfig, "bspdatalayerurl", "")}${url}`, {
		...options,
		method: "PUT"
	});


export const postBsp = (url: string, options: any) =>
	request(`${_.get(envConfig.publicRuntimeConfig, "bspdatalayerurl", "")}${url}`, {
		...options,
		method: "POST"
	});

export const deleteBsp = (url: string, options: any) =>
	request(`${_.get(envConfig.publicRuntimeConfig, "bspdatalayerurl", "")}${url}`, {
		...options,
		method: "DELETE"
	});
export const getEndpoints = (url: string, options: any) =>
	request(url, {
		...options,
		method: "GET"
	});

export const postEndpoints = (url: string, options: any) =>
	request(url, {
		...options,
		method: "POST"
	});

export const handleResponse = async (res: any) => {
		if (res.status >= 200 && res.status < 400) {
			if (typeof window != "undefined" && has(res, "status")) {

				let parsedRes = res.data;
				let parsedReqData = res.config.data;

				if (res.data && res.config && includes(res.config.url, "storewebprospecteg") == true) {
					parsedRes = {
						contractStatus: lodashGet(res, "data.Status", "0"),
						contractTxtStatus: lodashGet(res, "data.txtStatus", "")
					};
					parsedReqData = JSON.parse(res.config.data);
				}

				if (res.data && res.config && includes(res.config.url, "SimulationOfAllProductsM6") == true) {
					let simulationArr = map(lodashGet(res, "data.Simulation", []), (item) => ({
						...item,
						BonusAndDiscount: JSON.stringify(item.BonusAndDiscount),
						Sections: JSON.stringify(item.Sections)
					}));

					parsedRes = {
						UCI: lodashGet(res, "data.UCI", ""),
						AnswerIsWithElectricity: lodashGet(res, "data.AnswerIsWithElectricity", "0"),
						AnswerIsWithGaz: lodashGet(res, "data.AnswerIsWithGaz", "0"),
						Request: lodashGet(res, "data.Request", {}),
						Simulation: simulationArr
					};
				}
				if (res.data && res.config && includes(res.config.url, "GetFunnelProperties") == true) {

					parsedRes = {
						...parsedRes,
						Catalogue: JSON.stringify(lodashGet(res, "data.Catalogue", []))
					};
				}
				if (res.data && res.config && includes(res.config.url, "/locations/postCode") == true) {

					parsedRes = {
						isDataReceived: (res.data && res.data.data && size(res.data.data) > 0),
						resultsCount: size(res.data.data)
					};
				}
				if (res.data && res.config && includes(res.config.url, "/GetCompanyTypes") == true) {

					parsedRes = {
						isDataReceived: (res.data && size(res.data) > 0),
						resultsCount: size(res.data)
					};
				}

				try {
					const logReq = {
						status: res.status,
						statusText: res.statusText,
						responseData: parsedRes,
						method: res.config.method,
						url: res.config.url,
						requestParams: res.config.params ?? {},
						requestData: parsedReqData
					};

					await axios(
						"/api/logger",
						{
							method: 'POST',
							data: {
								hasError: false,
								log: {
									logData: logReq,
									project: "MIG"
								}
							}
						}
					);
				} catch (e) {
						console.log("Error caught");
						console.log(e)
					}
			}

			return {
				ok: true,
				statusCode: res.status,
				statusText: res.statusText,
				message: "",
				data: res.data
			};
		} else {
			if (typeof window != "undefined" && has(res, "status")) {
				const logReq = {
					status: res.response?.status,
					statusText: res.response?.statusText,
					responseData: (typeof res.response?.data == 'string') ? {message: res.response?.data} : res.response?.data,
					method: res.config?.method,
					url: res.config?.url,
					requestParams: res.config?.params,
					requestData: res.config?.data ?? {}
				};

				try {
					await axios(
						"/api/logger",
						{
							method: 'POST',
							data: {
								hasError: true,
								log: {
									logData: logReq,
									project: "MIG"
								}
							}
						}
					);
				} catch (err) {
					console.log(err)
				}
			}
		}

	console.log("handleResponse Err");

	let error = new Error("Error");

	throw error;
};

export const handleError = async (err: any) => {

	if (typeof window != "undefined" && err) {

		try {
			await axios(
				"/api/logger",
				{
					method: 'POST',
					data: {
						hasError: true,
						log: {
							logData: {
								status: _.get(err, "response.status", 500),
								statusText: _.get(err, "response.statusText", ""),
								responseData: (typeof err.response?.data == 'string') ? {message: err.response?.data} : _.get(err, "response.data", {}),
								method: _.get(err, "config.method", ""),
								url: _.get(err, "config.url", ""),
								requestParams: _.get(err, "config.params", {}),
								requestData: _.get(err, "config.data", {})
							},
							project: "MIG"
						}
					}
				}
			);
		} catch (err) {
			console.log(err)
		}

	}

	if (err.response) {
		return {
			ok: false,
			statusCode: err.response.status,
			statusText: err.response.statusText,
			message: err.response.data,
			data: null
		};
	}

	return {
		ok: false,
		statusCode: 500,
		statusText: "Error",
		message: "Unknown error",
		data: null
	};
};

export default request;
